import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { PathDelay } from "./PathDelay";
import { deepExtend } from "../../../../../Utils/Utils";
export var Path = /*#__PURE__*/function () {
  function Path() {
    _classCallCheck(this, Path);
    this.clamp = true;
    this.delay = new PathDelay();
    this.enable = false;
    this.options = {};
  }
  _createClass(Path, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }
      if (data.clamp !== undefined) {
        this.clamp = data.clamp;
      }
      this.delay.load(data.delay);
      if (data.enable !== undefined) {
        this.enable = data.enable;
      }
      this.generator = data.generator;
      if (data.options) {
        this.options = deepExtend(this.options, data.options);
      }
    }
  }]);
  return Path;
}();